import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpParams,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class RemoveEmptyParamsInterceptor implements HttpInterceptor {
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (!req.params || req.params.keys().length === 0) {
            return next.handle(req);
        }
        let cleaned: HttpParams = new HttpParams();
        req.params.keys().forEach((key) => {
            const value = req.params.get(key);
            if (value !== null && value !== undefined && value !== '') {
                cleaned = cleaned.set(key, value);
            }
        });
        return next.handle(req.clone({ params: cleaned }));
    }
}
